import { Stack, Typography, Button } from '@mui/material';

export default function AddonsHeader({ onNew, onLogout }) {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
      <Typography variant="h5">Addons Admin</Typography>

      <Stack direction="row" spacing={1}>
        <Button variant="contained" onClick={onNew}>
          + New Addon
        </Button>
        <Button variant="outlined" color="error" onClick={onLogout}>
          Logout
        </Button>
      </Stack>
    </Stack>
  );
}